{
  "commonHeader": {
    "toggleSidebar": "Bật hoặc tắt thanh bên",
    "cartLoading": "Đang tải giỏ hàng",
    "cart": "Giỏ hàng",
    "aicForAdmin": {
      "ariaLabel": "AI dành cho quản trị viên"
    },
    "usersResults": "Người dùng, {0} kết quả",
    "settingsResults": "Cài đặt, {0} kết quả",
    "navigationResults": "Điều hướng, {0} kết quả",
    "learnMoreAbout": "Tìm hiểu thêm về {0}",
    "close": "Đóng",
    "products": "Sản phẩm",
    "moreActions": "Thêm thao tác",
    "search": "Tìm kiếm",
    "searchPlaceholderAll": "Tìm người dùng, cài đặt tài khoản hoặc điều hướng",
    "searchPlaceholderUsers": "Tìm người dùng hoặc điều hướng",
    "searchPlaceholderSettings": "Tìm cài đặt tài khoản hoặc điều hướng",
    "searchPlaceholderNav": "Tìm điều hướng"
  },
  "footerCopyright": {
    "language": "Ngôn ngữ {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Menu quản trị"
    }
  },
  "shared": {
    "close": "Đóng",
    "sideMenu": {
      "personalAria": "Menu cá nhân",
      "adminAria": "Menu quản trị",
      "mainNav": "Điều hướng chính",
      "submenu": "Menu phụ",
      "pinnedSection": "{0} đã ghim",
      "sideMenuAria": "Menu bên",
      "pinItem": "Ghim {0}",
      "unpinItem": "Bỏ ghim {0}",
      "reorderGrabbed": "Sắp xếp lại {0}, đã nắm. Dùng phím mũi tên lên và xuống để di chuyển, phím cách hoặc Enter để thả, Escape để hủy.",
      "reorderIdle": "Sắp xếp lại {0}. Nhấn phím cách hoặc Enter để nắm.",
      "hintHandlePin": "Nhấn Tab để truy cập tay cầm kéo và nút ghim",
      "hintHandle": "Nhấn Tab để truy cập tay cầm kéo",
      "hintPin": "Nhấn Tab để truy cập nút ghim",
      "upgradeToPro": "Nâng cấp lên Pro"
    },
    "item": "Mục"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Dùng thử trải nghiệm mới"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Đóng"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Phân khu hiện đã có sẵn"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Quản lý tài khoản bên ngoài"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Sổ địa chỉ sẽ trở thành Thư mục khách hàng"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Khu vực sản phẩm",
    "itemLableForFeedback": "Phản hồi"
  }
}
